var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0225 7.47513C14.0225 9.8833 12.07 11.8345 9.66313 11.8345C7.25496 11.8345 5.30243 9.8833 5.30243 7.47513C5.30243 5.06697 7.25496 3.11572 9.66313 3.11572C12.07 3.11572 14.0225 5.06697 14.0225 7.47513Z",
    stroke: "#525355",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9512 5.80168C14.5605 5.12983 15.4405 4.70795 16.419 4.70795C18.2568 4.70795 19.7478 6.1979 19.7478 8.03676C19.7478 9.87561 18.2568 11.3656 16.419 11.3656C15.2455 11.3656 14.2138 10.7589 13.6207 9.84193",
    stroke: "#525355",
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69676 15.0197C12.9087 15.0115 15.6397 16.4863 16.6435 19.6609C14.6202 20.8943 12.2385 21.3694 9.69676 21.3632C7.15505 21.3694 4.77337 20.8943 2.75 19.6609C3.755 16.4829 6.4814 15.0115 9.69676 15.0197Z",
    stroke: "#525355",
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4454 18.6407C18.3863 18.6454 20.2049 18.2827 21.7499 17.3408C20.9834 14.9167 18.898 13.7906 16.4454 13.7969C14.9005 13.7929 13.5034 14.2363 12.4886 15.1702",
    stroke: "#525355",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.2daef1b7c967650bd86c2667ed4945c5.svg";
export { ForwardRef as ReactComponent };